import Api from "@/configurations/Api";
import RequestService from "@/configurations/AxiosConfig";
import { IAttendanceCodesAndShiftsRequest, ICreateAttendanceRecordRequest, IExportAttendanceToExcel, IExportAttendanceToPdf } from "@/types/type";
import { format } from "date-fns";
import { tr } from "date-fns/locale";
import { toast } from "sonner";

const endpoints = {
  attendanceRecords: 'attendance-records',
  getAttendanceLogs: 'attendance-records/getLogs',
  getLockedDates: 'attendance-records/getLockedDates',
};

const AttendanceRecordsService = {
  createAttendanceRecords: (data: any) => RequestService.post(endpoints.attendanceRecords, data),
  updateAttendanceRecords: (data: any) => RequestService.patch(endpoints.attendanceRecords, data),
  getAllAttendanceRecords: (data: ICreateAttendanceRecordRequest) => RequestService.post(`${endpoints.attendanceRecords}/getAll`, data),
  getAllAttendanceCodesAndShifts: (data:IAttendanceCodesAndShiftsRequest) => RequestService.post(`${endpoints.attendanceRecords}`, data),
  getAttendanceLogs: (data: {company_id: number, date: string}) => RequestService.post(endpoints.getAttendanceLogs, data),
  getLockedDates: (data: {company_id: number, date: string}) => RequestService.post(endpoints.getLockedDates, data),
  exportAttendanceToExcel: async (data: IExportAttendanceToExcel) => {
    const response = await fetch(`${Api.getBaseUrl()}attendance-records/exportAttendanceToExcel`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const blob = await response.blob()
  
    if (!blob.type.includes("spreadsheet") && !blob.type.includes("excel")) {
      console.warn("Response might not be an Excel file:", blob.type)
    }
  
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = 'attendance.xlsx'
  
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  
    window.URL.revokeObjectURL(downloadUrl)
  
    toast.success("Dosya başarıyla indirildi.")
  },
  exportAttendanceToPdf: async (data: IExportAttendanceToPdf) => {
    const response = await fetch(`${Api.getBaseUrl()}attendance-records/exportAttendanceToPdf`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
  
    const blob = await response.blob()
  
    if (!blob.type.includes("spreadsheet") && !blob.type.includes("pdf")) {
      console.warn("Response might not be a PDF file:", blob.type)
    }
  
    const downloadUrl = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = downloadUrl
    link.download = `attendance-${format(new Date(data.date), 'MMMM-yyyy', { locale: tr })}.pdf`
  
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  
    window.URL.revokeObjectURL(downloadUrl)
  
    toast.success("Dosya başarıyla indirildi.")
  },
};

export default AttendanceRecordsService;
